<!--
 * @Author       : qixiao
 * @Date         : 2023-05-13 16:22:24
 * @LastEditors  : qixiao
 * @LastEditTime : 2023-05-15 15:13:50
 * @FilePath     : \hzs-Houtai\src\views\Agricultural\AgriculturalMonitoring\component\LandMapNq\MapRightInfo.vue
 * @Description  : 
 * 
-->
<!--
 * @Author: liushumin
 * @Date: 2022-05-28 00:04:32
 * @LastEditTime: 2022-07-04 10:52:01
 * @LastEditors: yangsibo
-->
<template>
  <div class="map-right-info">
    <div class="map-right-info-content">
      <!-- 地块、作业、审核 -->
      <div class="land-detail">
        <el-tabs v-model="activeName">
          <el-tab-pane label="地块信息" name="first">
            <div class="land-info" v-if="landInfo">
              <ul class="list">
                <li class="item">
                  <div class="left-side">
                    <i class="iconfont icon-dikuaibianhao"></i>
                  </div>
                  <div class="right-side">
                    <p class="tit">地块编号</p>
                    <p class="name">{{ landInfo.croplandId }}</p>
                  </div>
                </li>

                <li class="item">
                  <div class="left-side">
                    <i class="iconfont icon-dikuaimianji"></i>
                  </div>
                  <div class="right-side">
                    <p class="tit">地块面积</p>
                    <p class="name">{{ landInfo.croplandArea }}亩</p>
                  </div>
                </li>
                <li class="item">
                  <div class="left-side">
                    <i class="iconfont icon-dikuaizhouchang"></i>
                  </div>
                  <div class="right-side">
                    <p class="tit">地块周长</p>
                    <p class="name">{{ landInfo.croplandPerimeter }}米</p>
                  </div>
                </li>
                <li class="item">
                  <div class="left-side">
                    <i class="iconfont icon-a-1dikuaiweizhi"></i>
                  </div>
                  <div class="right-side">
                    <p class="tit">地块位置</p>
                    <p class="name">{{ landInfo.address }}</p>
                  </div>
                </li>
              </ul>
            </div>
          </el-tab-pane>
          <el-tab-pane label="作业信息" name="second" v-if="false">
            <div class="work-info" v-if="workInfo">
              <p class="type">作业类型：{{ workInfo.workTypeName }}</p>
              <div class="info">
                <div class="cell">
                  <p class="tit">
                    <span class="large">{{ workInfo.trueWorkArea || 0 }}</span
                    >亩
                  </p>
                  <p class="name">已作业</p>
                </div>
                <div class="cell">
                  <p class="tit">
                    <span class="large">{{ workInfo.completeRate || 0 }}</span
                    >%
                  </p>
                  <p class="name">完成率</p>
                </div>
              </div>
              <ul
                class="list"
                v-if="
                  workInfo.machinePersonWorks &&
                  workInfo.machinePersonWorks.length > 0
                "
              >
                <li
                  class="item"
                  v-for="(item, index) in workInfo.machinePersonWorks"
                  :key="index"
                >
                  <p>机手：{{ item.driverName }}</p>
                  <p>作业机具：{{ item.machineName }}</p>
                  <p>出厂编号：{{ item.machineryCode }}</p>
                  <p>北斗终端类型：{{ item.iotTypeName }}</p>
                  <p>北斗终端编号：{{ item.imei }}</p>
                  <p>作业面积：{{ item.workArea }}亩</p>
                </li>
              </ul>
            </div>
          </el-tab-pane>
          <el-tab-pane label="审核信息" name="third" v-if="false">
            <div class="audit-info" v-if="auditInfo">
              <div v-for="(item, index) in auditInfo" :key="index">
                <ul class="list">
                  <li class="item">
                    <p>审核时间：</p>
                    <p>审核员：</p>
                    <p>审核结果：</p>
                    <p>备注：</p>
                  </li>
                </ul>
                <ImagePreview
                  :previewList="item.srcList"
                  @handlePreviewImg="handlePreviewImg"
                ></ImagePreview>
              </div>
            </div>
          </el-tab-pane>
        </el-tabs>
      </div>
    </div>
    <el-image
      ref="previewImg"
      style="width: 0; height: 0"
      :src="previewSrcList[0]"
      :preview-src-list="previewSrcList"
    >
    </el-image>
  </div>
</template>

<script>
import ImagePreview from "./ImagePreview";
export default {
  data() {
    return {
      activeName: "first",
      activeNameT: "first",
      landInfo: {
        croplandVillGroupName: "四川剑阁县恒禾智慧农场",
        address: "四川剑阁县",
        croplandFranchisedTypeName: "土地流转",
        croplandProprietor: "夏卫华",
        croplandId: "0012",
        croplandTypeName: "耕地",
        croplandPerimeter: "125",
        croplandArea: "25",
      }, // 地块切卡的地块信息（地图右侧信息）
      workInfo: {}, // 地块切卡的作业信息（地图右侧信息）
      auditInfo: [], // 地块切卡的审核信息（地图右侧信息）
      previewSrc: "",
      previewSrcList: [],
      trajectoryInfo: {}, //轨迹的信息（地图右侧信息）
      trajectoryBlockInfo: [], //轨迹的地块信息（地图右侧信息）
      assignDetail: {}, // 派活信息（地图右侧信息）
    };
  },
  components: { ImagePreview },
  props: ["landId"],
  watch: {
    landId() {
      this.getLandMsg();
    },
  },
  mounted() {
    this.getLandMsg();
  },
  methods: {
    // 预览图片
    handlePreviewImg(data) {
      this.previewSrcList = data;
      this.$refs.previewImg.showViewer = true;
    },
    getLandMsg() {
      console.log('地块');

      this.landInfo = {};
      if (this.landId) {
        // this.$http.work.getLandDetail({ id: this.landId }).then((res) => {
        //   this.landInfo = res.data;
        // });
        // this.$http.work.getWorkLandDetails({ workLandId: this.landId }).then((res) => {
        //   this.workInfo = res.data;
        // });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.map-right-info {
  background: transparent !important;
  .map-right-info-content {
    height: 100%;
    padding: 15px;
    box-sizing: border-box;
    overflow-y: auto;
    /*滚动条样式*/
    &::-webkit-scrollbar {
      width: 4px;
    }
    &::-webkit-scrollbar-thumb {
      border-radius: 10px;
      box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
      background: rgba(255, 255, 255, 0.2);
    }
    &::-webkit-scrollbar-track {
      box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
      border-radius: 0;
      background: rgba(255, 255, 255, 0.1);
    }
  }
  .land-detail {
    .land-info {
      .list {
        .item {
          display: flex;
          align-items: center;
          min-height: 70px;
          border-bottom: 1px solid #3d403b;
          // &:not(:last-child) {
          //   border-bottom: 1px solid #3d403b;
          // }
          .left-side {
            margin: 10px 20px;
            i {
              color: #2ac9cf;
              font-size: 36px;
            }
          }
          .right-side {
            flex: 1;
            margin: 10px 0;
            .tit {
              color: #2ac9cf;
            }
            .name {
              font-size: 18px;
              color: #d0e7e8;
            }
          }
          .cell {
            display: flex;
            align-items: center;
            width: 50%;
            min-height: 70px;
            &:first-child {
              border-right: 1px solid #3d403b;
            }
            .left-side {
              margin: 0 10px;
            }
          }
        }
      }
    }
    .work-info {
      color: #d0e7e8;
      font-size: 14px;
      .type {
        margin-top: 20px;
      }
      .info {
        display: flex;
        align-items: center;
        justify-content: space-around;
        padding: 20px 0 25px;
        .cell {
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          .tit {
            color: #ffe400;
            .large {
              font-size: 28px;
            }
          }
        }
      }
      .list {
        .item {
          padding: 15px 0;
          line-height: 26px;
          color: #d0e7e8;
          border-top: 1px solid #3d403b;
        }
      }
    }
    .audit-info {
      color: #d0e7e8;
      font-size: 14px;
      .list {
        .item {
          padding: 15px 0 0;
          line-height: 26px;
          color: #d0e7e8;
          border-top: 1px solid #3d403b;
        }
      }
    }
  }
}
</style>
